/**
 * Bridges the shared DateRangePicker (which works in Date objects) and the
 * portal's ISO 'YYYY-MM-DD' date-filter state. Parsing and formatting are done
 * in LOCAL time so a day picked in the calendar round-trips to the same
 * calendar day — toISOString() would shift it across the UTC boundary.
 */

export function parseIsoDate(iso: string): Date | null {
	if (iso === '') {
		return null;
	}
	const parts = iso.split('-');
	if (parts.length !== 3) {
		return null;
	}
	const year = Number(parts[0]);
	const month = Number(parts[1]);
	const day = Number(parts[2]);
	if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
		return null;
	}
	return new Date(year, month - 1, day);
}

export function toIsoDate(date: Date | null): string {
	if (date == null) {
		return '';
	}
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}
